import * as React from "react"
import type { SVGProps } from "react"
const SvgSparkle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m20.43 7.85-.6 1.36a.37.37 0 0 1-.66 0l-.6-1.36-1.35-.59a.37.37 0 0 1 0-.67L18.58 6l.59-1.35a.37.37 0 0 1 .66 0l.6 1.35 1.35.6a.37.37 0 0 1 0 .66zm-3.6 13.36.6-1.36 1.35-.59a.37.37 0 0 0 0-.67L17.42 18l-.59-1.35a.37.37 0 0 0-.67 0L15.57 18l-1.35.6a.37.37 0 0 0 0 .66l1.35.6.6 1.35a.37.37 0 0 0 .66 0" />
    <path
      fillRule="evenodd"
      d="M9.19 18.24a.36.36 0 0 0 .62 0l2.13-3.87 3.87-2.13a.36.36 0 0 0 0-.63L11.94 9.5 9.81 5.62a.36.36 0 0 0-.62 0L7.06 9.49 3.19 11.6a.36.36 0 0 0 0 .63l3.87 2.13zm3.04-6.31-1.76.97-.97 1.76-.97-1.76-1.76-.97 1.76-.97.97-1.76.97 1.76z"
    />
  </svg>
)
export default SvgSparkle
